import { Stack } from '@mui/material';
import type { CommissionPricingConfiguration, Currency, LineItemProduct } from '@weft/types';
import { formatNumber, isNotNullOrUndefined } from '@weft/utils';
import { formatPercentage } from 'apps/app/src/utils/number';
import { DynamicInvoiceProductLineItemDetail } from './DynamicInvoiceProductLineItemDetail';

type DynamicInvoiceProductLineItemDetailsProps = {
  isCommission: boolean;
  commitmentUnits: number;
  isNotFixedLineItem: boolean;
  pricingConfiguration: CommissionPricingConfiguration | undefined;
  lineItemPrice: number;
  currency: Currency;
  lineItemProduct: LineItemProduct;
};

export const DynamicInvoiceProductLineItemDetails: React.FC<DynamicInvoiceProductLineItemDetailsProps> = ({
  isCommission,
  commitmentUnits,
  isNotFixedLineItem,
  pricingConfiguration,
  lineItemPrice,
  currency,
  lineItemProduct,
}) => {
  const currencyCommitment = lineItemProduct.currencyCommitment;

  return (
    <Stack
      direction="row"
      spacing={4}
      flexGrow={1}
      justifyContent="flex-end"
    >
      {isCommission && (
        <DynamicInvoiceProductLineItemDetail
          label="Rate"
          value={isNotNullOrUndefined(pricingConfiguration) && formatPercentage(pricingConfiguration.percentage)}
        />
      )}

      { isNotNullOrUndefined(currencyCommitment) && (
        <DynamicInvoiceProductLineItemDetail
          label="Prepaid Amount"
          currency={currency}
          value={formatNumber(currencyCommitment)}
        />
      )}

      {isNotFixedLineItem && (
        <DynamicInvoiceProductLineItemDetail
          label="Units"
          value={formatNumber(commitmentUnits)}
        />
      )}

      <DynamicInvoiceProductLineItemDetail
        label="Amount"
        alignItems="flex-end"
        isPrice
        value={lineItemPrice}
        currency={currency}
        sx={{
          paddingRight: isCommission ? '40px' : 0,
        }}
      />
    </Stack>
  );
};
